<template>
  <div>
    <div id="nav">
      <h2>Welcome!</h2>
      <p>
      <p> Enter and explore the rooms, click on the hotspots to find out more!</p>
      <div class="hotspot-progress"><strong>Scenarios completed: <span class="hotspot-remaining">{{questionsAnswered}}</span>/<span class="hotspot-total">{{allQuestions}}</span></strong></div>
      <router-link :to="{ name: 'communual-area' }"><div class="m-btn m-btn__primary room1">Communual Area &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
      <router-link :to="{ name: 'bedroom' }"><div class="m-btn m-btn__primary room2">Bedroom &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
      <router-link :to="{ name: 'kitchen' }"><div class="m-btn m-btn__primary room3">Kitchen &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
      <div class="nav-close" @click="$emit('close')"><div class="m-btn__cross"></div></div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['questionsAnswered', 'allQuestions'],
  name: 'Navigation'
}
</script>

<style scoped lang="scss">

.nav-close {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.m-btn {
  background: #fff;
  &:hover {
    background: #f2f2f2;
  }
}

ul {
  margin: 0;
}

.hotspot-progress {background:#ffcc0b;padding:8px 13px;position:absolute;top:-50px;height:50px;font-size:1.2rem;}
.hotspot-remaining {font-size:1.5rem;}
.hotspot-total {}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue